<template>
  <div class="grid-wrap">
    <div class="grid-row">
      <article class="grid-col grid-col--soft grid-xsmall-12 grid-large-9 push__bottom">
        <div class="push__top">
            <BackLink/>
        </div>       
        <Panel :title="title" variant="success" />
        <div class="wysiwyg">
            <p v-html="content"></p>
            <p>
                <button class="btn btn--primary" @click="goToNext">{{buttonText}}<span class="visually-hidden"> {{buttonTextHidden}}</span></button>
            </p>
        </div>                
      </article>
    </div>
  </div>
</template>

<script>
import { dataService } from "../shared";

export default {
  name: "Completed",
  created() {
    this.loadQuestion();
  },
  data() {
    return {
      title: "",
      content: "",
      destination: "",
      buttonText: "",
      buttonTextHidden: ""
    };
  },
  methods: {
    loadQuestion() {
      let json = dataService.getQuestions();
      let questions = json.questions;
      let currentQuestion = dataService.findElement(
        questions,
        dataService.parseUrl()
      );
      this.title = currentQuestion.title;
      this.content = currentQuestion.content;
      this.destination = currentQuestion.destination;
      this.buttonText = currentQuestion.buttonText;
      this.buttonTextHidden = currentQuestion.buttonTextHidden;
      console.log(this.destination);
    },
    redirectToTimeout() {
      dataService.resetResponses();
      this.$router.push({ name: "timeout" });
    },
    goToNext() {
        this.$router.push({ name: this.destination.toLowerCase() });
    }
  }
};
</script>